import React from 'react'
import { Invoice } from '../../../../back-end/common/invoice'
import { Loading } from '../ui/Loading/Loading'
import { Col, Modal, ModalBody, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { DateTime } from 'luxon'

import './invoiceInfoCard.css'
import { Edit } from 'react-feather'
import NewInvoiceScreen from '../../screens/invoice/newInvoice'

interface InvoiceInfoCardProps {
	invoice: Invoice | null | undefined
	setInvoice?: (value: Invoice | null) => void
}

const InvoiceInfoCard = ({ invoice, setInvoice }: InvoiceInfoCardProps) => {
	const [showEdit, setShowEdit] = React.useState<boolean>(false)
	if (!invoice) {
		return (
			<div className="invoice-info-card">
				<Loading show />
			</div>
		)
	}

	const col = [4, 4, 4]

	const ContactInfo = () => (
		<div>
			<Row>
				<Col sm="auto">{invoice.contacts.length > 0 ? invoice.contacts.flatMap((c) => c.email).join(', ') : 'No Email'}</Col>
				<Col />
			</Row>
			{invoice.client ? (
				<>
					<Row>
						<Col sm="auto">{invoice.client.postalAddress}</Col>
						<Col />
					</Row>
					<Row>
						<Col sm="auto">
							{invoice.client.postalCity}, {invoice.client.postalRegion} {invoice.client.postalPostCode}
						</Col>
						<Col />
					</Row>
					<Row>
						<Col sm="auto">{invoice.client.postalCountry}</Col>
						<Col />
					</Row>
				</>
			) : (
				<Row>
					<Col>No Address</Col>
				</Row>
			)}
		</div>
	)

	return (
		<div className="invoice-info-card">
			{
				['DRAFT', 'SUBMITTED'].includes(invoice.status) && setInvoice ?
					<span style={{ position: 'relative', display: 'inline-block', marginTop: '-8px' }}>
						<Edit style={{ position: 'absolute', right: -10, top: 8 }} color='white' onClick={() => setShowEdit(true)} />
					</span> : null
			}
			<Row>
				<CardItem label="Invoice No" value={invoice.number} width={col[0]} />
				<CardItem label="Invoice Date" value={DateTime.fromISO(invoice.date).toFormat('d MMM yyyy')} width={col[1]} />
				<CardItem label="Due Date" value={DateTime.fromISO(invoice.dueDate).toFormat('d MMM yyyy')} width={col[2]} />
			</Row>
			<Row>
				<CardItemWithTooltip label="Client" value={invoice.client?.name} width={col[0]} tooltip={<ContactInfo />} />
				<CardItem label="Invoiced By" value={invoice.xeroOrg.name} width={col[1]} />
				<CardItem label="Created By" value={invoice.createUser.firstName + ' ' + invoice.createUser.lastName} width={col[2]} />
			</Row>
			<Modal show={showEdit} onHide={() => setShowEdit(false)} size='xl'>
				<ModalBody>
					<NewInvoiceScreen editInvoice={invoice} setEditInvoice={setInvoice} closeModal={() => setShowEdit(false)} />
				</ModalBody>
			</Modal>
		</div>
	)
}

const CardItem = ({ label, value, width }: { label: string; value?: string; width: number }) => (
	<Col sm={width}>
		<span className="span-white">{label}: </span>
		<span className="span-white span-bold">{value}</span>
	</Col>
)

const CardItemWithTooltip = ({ label, value, width, tooltip }: { label: string; value?: string; width: number; tooltip: React.ReactNode }) => (
	<Col sm={width}>
		<OverlayTrigger placement="bottom" overlay={(props) => <Tooltip {...props}>{tooltip}</Tooltip>}>
			<div>
				<span className="span-white">{label}: </span>
				<span className="span-white span-bold">{value}</span>
			</div>
		</OverlayTrigger>
	</Col>
)

export default InvoiceInfoCard
